import Dialog from './Dialog';
import React, { useState } from 'react';

const FEELINGS = [
  { key: 'calmer', label: 'Calmer' },
  { key: 'same', label: 'About the same' },
  { key: 'less', label: 'Not really' },
];

// An entirely optional, one-tap "how do you feel now?" — answering it (or
// not) never blocks moving on. Once answered it just quietly acknowledges the
// choice rather than asking again.
const RoutineComplete = ({ routine, onDone, onCheckIn }) => {
  const [feeling, setFeeling] = useState(null);

  const chooseFeeling = (key) => {
    if (feeling) return; // already answered — no re-counting
    setFeeling(key);
    onCheckIn?.(key);
  };

  return (
    <Dialog onClose={onDone} labelledBy="routine-complete-title" className="fixed inset-0 z-complete flex items-center justify-center bg-black/85 p-5">
      <div className="w-full max-w-sm rounded-3xl border border-indigo-300/20 bg-gradient-to-b from-slate-900 to-[#10172a] p-7 text-center shadow-2xl">
        <div aria-hidden="true" className="mx-auto h-16 w-16 rounded-full bg-gradient-to-br from-blue-400 to-purple-500 shadow-[0_0_35px_rgba(129,140,248,.45)]" />
        <h2 id="routine-complete-title" className="mt-6 text-2xl font-bold text-white">A moment completed</h2>
        <p className="mt-2 text-sm leading-relaxed text-white/55">You completed {routine.title}. Take your time before moving on.</p>

        <div className="mt-6 border-t border-white/10 pt-5">
          {feeling ? (
            <p className="text-sm font-semibold text-indigo-200/80">Thank you for noticing.</p>
          ) : (
            <>
              <p className="text-xs font-semibold uppercase tracking-widest text-white/35">How do you feel now? (optional)</p>
              <p className="mt-2 text-xs text-white/55">Your answer adds to private counts in your account. We do not save individual answers.</p>
              <div className="mt-3 grid grid-cols-3 gap-2">
                {FEELINGS.map(({ key, label }) => (
                  <button
                    key={key}
                    type="button"
                    onClick={() => chooseFeeling(key)}
                    className="min-h-11 rounded-xl border border-white/10 bg-white/5 px-2 py-2 text-xs font-bold text-white/70 transition-colors hover:bg-white/10 active:scale-[.98]"
                  >
                    {label}
                  </button>
                ))}
              </div>
            </>
          )}
        </div>

        <button type="button" onClick={onDone} className="mt-6 w-full rounded-2xl bg-gradient-to-r from-blue-600 to-purple-600 p-3 font-bold text-white">Done</button>
      </div>
    </Dialog>
  );
};

export default RoutineComplete;
